<template>
	<v-card class="px-4 pt-2 pb-4" color="rgba(41, 41, 47, 0.8)">
		<v-card-title> {{ $t("ADD_LINEWORK_INFO") }} </v-card-title>
		<v-card-text>
			<v-form v-model="isValid">
				<v-row class="justify-center">
					<line-works-cross-section-input :cross-section-data="crossSectionData" :is-sima="isSima"></line-works-cross-section-input>
				</v-row>
				<v-row>
					<v-card-actions class="full-width justify-end mt-2">
						<v-btn variant="flat" @click="closeDialog" color="red">
							{{ $t("CANCEL") }}
						</v-btn>
						<v-btn variant="flat" @click="generateCrossSection()" color="primary" :disabled="!isValid">
							{{ $t("ADD") }}
						</v-btn>
					</v-card-actions>
				</v-row>
			</v-form>
		</v-card-text>
	</v-card>
</template>


<script>
import { useUnitDisplay } from "@/composables/useUnitDisplay";
import rules from "@/utils/validation-rules.js";
import { mapActions, mapState } from "vuex";
import LineWorksCrossSectionInput from "./LineWorksCrossSectionInput.vue";
import { defaultLineWorksCrossSectionByDistanceUnit } from "./default";

export default {
	name: "LineWorksCrossSectionDialog",
	setup() {
		const { siteUnits, fromDisplayDistance } = useUnitDisplay();
		const createDefaultCrossSection = () =>
			defaultLineWorksCrossSectionByDistanceUnit(
				siteUnits.value.distance,
				fromDisplayDistance,
			);
		return {
			createDefaultCrossSection,
		};
	},
	components: { LineWorksCrossSectionInput },
	props: {
		id: Number,
	},
	data() {
		return {
			crossSectionData: this.createDefaultCrossSection(),
			isValid: false,
			rules: {
				...rules,
				required: (value) => !!value || "*",
			},
		};
	},
	computed: {
		...mapState("simaLine", ["simaLineList"]),
		linearData() {
			return this.simaLineList.find((item) => item.lineId === this.id);
		},
		isSima() {
			return this.linearData?.lineType === "sima";
		},
	},
	methods: {
		...mapActions("simaLine", ["addCrossSectionSettingForSima"]),
		...mapActions("arbitraryLine", ["addCrossSectionSettingForArbitraryLine"]),
		resetProperty() {
			this.crossSectionData = this.createDefaultCrossSection();
			this.isValid = true;
		},
		closeDialog() {
			window["viewer"].cancelArbitraryCreation();
			this.$emit("close", false);
		},
		async generateCrossSection() {
			try {
				// ローディング開始
				await this.$store.dispatch("executeWithSpinner", async () => {
					try {
						const setting = {
							leftWidth: this.crossSectionData.leftWidth,
							rightWidth: this.crossSectionData.rightWidth,
							interpolationPitch: this.crossSectionData.interpolationPitch,
							samplingSize: this.crossSectionData.samplingSize,
						};
						const linearData = this.simaLineList.find(
							(item) => item.lineId === this.id,
						);
						if (linearData.lineType === "arbitrary") {
							await this.addCrossSectionSettingForSima({
								simaLine: linearData,
								crossSectionSetting: setting,
							});
						} else if (linearData.lineType === "sima") {
							await this.addCrossSectionSettingForSima({
								simaLine: linearData,
								crossSectionSetting: setting,
							});
						}
					} catch (e) {
						// Todo display appropriate message
						console.error(e);
					}
				});
			} finally {
				this.$emit("close", false);
			}
		},
	},
};
</script>

<style scoped>
.mt-0 {
	margin-top: 0;
}

.mt-2 {
	margin-top: 2em;
}

.pt-2 {
	padding-top: 2em;
}

.full-width {
	width: 100%;
}
</style>